import {IRestrictionValue} from "./restriction-value.interface";

export class NoRestrictionValue implements IRestrictionValue {
    isActiveRestrictionForOpenApplication(): boolean {
        return false;
    }

    isExpired(): boolean {
        return true;
    }

    isGameAllowedInTheGrid(): boolean {
        return true;
    }

    isGameAllowedToPlayReal(): boolean {
        return true;
    }

    showUserMessage(): void {
    }

}